import type { TFunction } from 'i18next';

import { useHomeownerTranslate } from 'src/modules/homeownerApp/hooks/useHomeownerTranslate';
import { MY_UPLOAD_STYLE } from 'src/modules/homeownerApp/static_values';
import type {
  AiDisplayImageFragment,
  AiGeneratedImageFragment,
} from 'src/shared/graphql/generated';

export const getGeneratedImageLabel = (
  image: AiGeneratedImageFragment | AiDisplayImageFragment | undefined | null,
  t: TFunction,
): string => {
  if (!image) {
    return '';
  }

  if (
    (image as AiGeneratedImageFragment)?.edits ||
    (image as AiDisplayImageFragment)?.aiGeneratedImage?.edits
  ) {
    return t('fullscreenImage.customized');
  }

  if (image.style === MY_UPLOAD_STYLE) {
    return t('fullscreenImage.original');
  }

  return image.style || '';
};

export const useGeneratedImageLabel = (
  image: AiGeneratedImageFragment | AiDisplayImageFragment | undefined | null,
) => {
  const t = useHomeownerTranslate();

  return getGeneratedImageLabel(image, t);
};
